import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IContractor } from '../../models/contractor.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class ContractorApiService {
  abstract getContractorList(): Observable<IContractor[]>;

  abstract getContractorListZip(
    zip: string,
    programtypes: string
  ): Observable<IContractor[]>;

  abstract getContractorListFilter(
    filterString: string,
    programtypes: string
  ): Observable<IContractor[]>;

  abstract getContractor(
    id: string,
    resetCache: boolean
  ): Observable<IContractor>;

  abstract updateContractor(contractor: IContractor): Observable<any>;

  abstract getContractorReviews(id: string): Observable<any>;
}
